'use strict';

/**
 * Removes all occurrences of a specified value from an array.
 *
 * @template T - The type of elements in the array.
 * @param {T[]} arr - The array from which to remove the value.
 * @param {T} value - The value to remove from the array.
 * @returns {T[]} - A new array with all occurrences of the value removed.
 */ function removeItemAll(arr, value) {
    let i = 0;
    while(i < arr.length){
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}

module.exports = removeItemAll;
